import React, { useEffect, useState } from "react";

const HourReportTabel = () => {
  const [sId, setSid] = useState("");

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");

    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        console.log("su_id:", userData?.data?.su_id);
        setSid(userData?.data?.su_id || "default");
      } catch (error) {
        console.error("Error parsing userData:", error);
      }
    } else {
      console.warn("No userData found in localStorage.");
    }
  }, []);

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {sId ? (
        <iframe
          src={`https://unit60.smartekanban.in/inline/inline_hourly_report/app/${sId}`}
          title="Hour Report"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      ) : (
        <p>Loading...</p> // Show a message until sId is set
      )}
    </div>
  );
};

export default HourReportTabel;
